<script>
import Layout from "@/views/layouts/main.vue";
import appConfig from "@/app.config.json";
import tableSearch from "@/mixins/tableSearch";
import pagination from "@/mixins/pagination";
import router from "@/mixins/router";
import { mapState } from "vuex";
import CommonTableComponent from "@/components/table.vue";
import sweetAlert from "@/mixins/sweetAlert";
import apiEndpoints from "@/services/apiEndpoints";
import user from "@/mixins/user";

export default {
  name: "system-settings",
  page: {
    title: "システム設定",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [tableSearch, pagination, router, sweetAlert,user],
  components: {
    Layout,
    CommonTableComponent
  },
  data() {
    return {
      data: []
    };
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const request = await this.$http.get(
        apiEndpoints.system_codes
      );
      this.isLoading = false;
      const { status, data } = request;

      if (status && data.result) {
        this.data = data.result;
      }
    },
    async submit() {
      this.isLoading = true;
      let data = this.data.forEach(item => {
        delete item.zz_system_code_category
      });
      const { status, code, result } = await this.$http.post(
        apiEndpoints.update_system_setting,
        this.data.map(item => { return {id: item.id, system_code_value: item.system_code_value} })
      );
      if (!status) {
        return this.errorToast(data.message);
      }
      this.isLoading = false;
      this.successToast("更新に成功しました。");
    }
  },
  computed: {
    ...mapState("options", ["system_codes"]),
    headers() {
      return [
        {
          text: "システムコード種類",
          width: 30
        },
        {
          text: "システムコード値"
        }
      ];
    }
  }
};
</script>

<template>
  <layout>
    <b-row>
      <b-card>
        <ValidationObserver v-slot="{ invalid }">
          <CommonTableComponent
            class="mt-3"
            :height-class="`table-wrapper-500`"
          >
            <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                  <span v-if="item.sortable" @click="clickSort(item.value)">
                    {{ item.text }}
                    <i :class="getSortClass(item.value)"></i>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data" :key="index">
                <td>
                  {{
                    item.zz_system_code_category &&
                      item.zz_system_code_category.system_code_category
                  }}
                </td>
                <td>
                  <ValidationProvider
                    rules="required|max:256"
                    v-slot="{ errors }"
                  >
                    <b-form-input
                      :id="`system_code_${item.id}`"
                      :name="`system_code_value`"
                      type="text"
                      v-model="item.system_code_value"
                    />
                    <span class="text-danger">{{
                      errors[0]
                        ? "このフィールドは空にできません。最大文字数は 256 文字です。"
                        : ""
                    }}</span>
                  </ValidationProvider>
                </td>
              </tr>

              <tr v-if="!data.length">
                <td :colspan="headers.length" class="text-center">
                  データなし。
                </td>
              </tr>
            </tbody>
          </CommonTableComponent>
          <div class="button-fixed-custom">
            <b-row class="mt-2" align-h="end">
              <b-col class="d-flex justify-content-center gap-2">
                <button
                  v-if="canUserEdit()"
                  :disabled="invalid"
                  class="mt-4 btn btn-primary"
                  @click="submit"
                >
                  <i class="fas fa-pencil-alt"></i> 更新
                </button>
              </b-col>
            </b-row>
          </div>
        </ValidationObserver>
      </b-card>
    </b-row>
  </layout>
</template>

<style lang="css"></style>
